import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import EquipmentTypeParameterForm from "components/equipmentTypes/parameters/EquipmentTypeParameterForm";
import { createEquipmentTypeParameter } from "graphql/mutations";
import { getEquipmentType, listEquipmentTypeParameters } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentTypeParameterCreateForm = ({ equipmentTypeID, onSuccess }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const equipmentTypeParameter = {
    parameterID: "",
    parameterValue: "",
  };

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { parameterID, parameterValue } = valuesParam;
      const oldEquipmentTypeParameterData = await API.graphql(
        graphqlOperation(listEquipmentTypeParameters, {
          filter: {
            and: [
              {
                equipmentTypeID: { eq: equipmentTypeID },
              },
              {
                parameterID: { eq: parameterID },
              },
            ],
            deletedAt: { attributeExists: false },
          },
        })
      );
      const oldEquipmentTypeParameterItems =
        oldEquipmentTypeParameterData.data.listEquipmentTypeParameters.items;

      if (oldEquipmentTypeParameterItems.length > 0) {
        toast.error(strings.parameterExists);
        return;
      }

      await API.graphql({
        query: createEquipmentTypeParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            equipmentTypeID,
            parameterID,
            parameterValue,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/equipment-types");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function getCompaniesFromEquipmentType(id) {
    try {
      const equipmentTypeData = await API.graphql(
        graphqlOperation(getEquipmentType, { id })
      );
      const equipmentTypeItem = equipmentTypeData.data.getEquipmentType;
      if (!equipmentTypeItem) {
        toast.error(strings.responses.errorFetchEquipmentType);
        return;
      }
      setCompanies(equipmentTypeItem.companies);
    } catch (err) {
      toast.error(strings.responses.errorFetchEquipmentType);
    }
  }

  useEffect(() => {
    getCompaniesFromEquipmentType(equipmentTypeID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentTypeID]);

  if (!companies || companies?.length <= 0) return <Loader />;

  return (
    <div>
      <EquipmentTypeParameterForm
        onSubmit={onSubmit}
        initialValues={equipmentTypeParameter}
        companies={companies}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Parámetro de Tipo de Equipo",
    successAdded: "Parámetro de Tipo de Equipo agregado con éxito",
    parameterExists: "El parámetro ya existe en el tipo de equipo",
    responses: {
      errorFetchEquipmentType: "Error al consultar tipo de equipo",
    },
  },
});

export default EquipmentTypeParameterCreateForm;
